import { Skeleton } from '@/components/ui'

export default function AnalysisSkeleton() {
  return (
    <div className="space-y-6">
      <div className="flex items-end justify-between">
        <div className="space-y-1">
          <Skeleton className="h-8 w-32" />
          <Skeleton className="h-5 w-80" />
        </div>
        <Skeleton className="h-10 w-44" />
      </div>

      <div className="grid grid-cols-1 gap-10 xl:grid-cols-[1fr_240px]">
        <div className="min-w-0">
          <div className="rounded-lg border border-border bg-card">
            <div className="p-8 space-y-8">
              {['overview', 'findings', 'recommendations', 'summary'].map(
                (section, sectionIndex) => (
                  <div key={section} className="space-y-4">
                    <Skeleton className="h-7 w-48" />

                    <div className="space-y-2">
                      <Skeleton className="h-4 w-full" />
                      <Skeleton className="h-4 w-full" />
                      <Skeleton className="h-4 w-11/12" />
                      <Skeleton className="h-4 w-4/5" />
                    </div>

                    {sectionIndex % 2 === 0 && (
                      <div className="space-y-2 pt-2">
                        <Skeleton className="h-4 w-full" />
                        <Skeleton className="h-4 w-10/12" />
                        <Skeleton className="h-4 w-3/4" />
                      </div>
                    )}

                    {sectionIndex === 1 && (
                      <div className="space-y-2 pl-4 pt-2">
                        <div className="flex items-center gap-2">
                          <Skeleton className="h-2 w-2 rounded-full" />
                          <Skeleton className="h-4 w-3/4" />
                        </div>
                        <div className="flex items-center gap-2">
                          <Skeleton className="h-2 w-2 rounded-full" />
                          <Skeleton className="h-4 w-2/3" />
                        </div>
                        <div className="flex items-center gap-2">
                          <Skeleton className="h-2 w-2 rounded-full" />
                          <Skeleton className="h-4 w-5/6" />
                        </div>
                      </div>
                    )}
                  </div>
                ),
              )}

              <div className="space-y-4">
                <Skeleton className="h-7 w-56" />
                <div className="space-y-2">
                  <Skeleton className="h-4 w-full" />
                  <Skeleton className="h-4 w-11/12" />
                  <Skeleton className="h-4 w-2/3" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="hidden xl:block">
          <div className="sticky top-8">
            <div className="rounded-lg border border-border bg-card">
              <div className="pb-4 pt-6 px-6">
                <Skeleton className="h-3 w-20" />
              </div>
              <div className="px-6 pb-6">
                <nav className="relative flex flex-col">
                  <div className="absolute left-0 top-0 bottom-0 w-px bg-border" />

                  {['nav-1', 'nav-2', 'nav-3', 'nav-4', 'nav-5'].map(
                    (id, i) => (
                      <div key={id} className="relative py-2 pl-4 pr-2">
                        <span className="absolute left-0 top-1/2 -translate-y-1/2 w-px h-4 bg-border" />
                        <Skeleton
                          className="h-4"
                          style={{ width: `${70 + (i % 3) * 15}%` }}
                        />
                      </div>
                    ),
                  )}
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
